import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import type { Campaign } from "common/types";

async function getCampaigns(workspaceId: string): Promise<Campaign[]> {
  const campaigns = (await get(`workspaces/${workspaceId}/campaigns`))
    .campaigns as Campaign[];

  return campaigns.sort(
    (campaignA, campaignB) => campaignB.created_at - campaignA.created_at,
  );
}

export default function useCampaigns() {
  const { id: workspaceId, permissions } = useSelectedWorkspaceContext();
  const { campaignsKeys } = getQueryKeys(workspaceId);

  const {
    data: campaigns,
    isLoading: isLoadingCampaigns,
    error: campaignsError,
    refetch: refetchCampaigns,
  } = useQuery<Campaign[]>({
    queryKey: campaignsKeys.list(),
    queryFn: () => getCampaigns(workspaceId),
  });

  const filteredCampaigns = permissions.includes("campaigns_full")
    ? campaigns
    : campaigns?.filter(({ state }) => state !== "INIT");

  return {
    campaigns: filteredCampaigns,
    campaignsError,
    isLoadingCampaigns,
    refetchCampaigns,
  };
}
